import React from 'react';
import { useParams } from 'react-router-dom';

import { ReportDetail } from '../components/Report/Details/ReportDetail.component';

export const ReportDetailPage: React.FC = () => {
  const { reportKey } = useParams();
  return <ReportDetail reportKey={reportKey} />;
};
